import React, { useState, useEffect, useRef } from 'react';
import './Stats.css';

const statsData = [
  { 
    number: 1000, 
    suffix: '+', 
    label: 'Projects Completed',
    description: 'Successfully delivered projects'
  },
  { 
    number: 10, 
    suffix: '+', 
    label: 'Years of Experience',
    description: 'Trusted experience in the industry'
  },
  { 
    number: 100, 
    suffix: '%', 
    label: 'Client Satisfaction',
    description: 'Commitment to quality and service'
  }
];

const Stats = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [counts, setCounts] = useState(statsData.map(() => 0));
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  useEffect(() => {
    if (isVisible) {
      statsData.forEach((stat, index) => {
        const duration = 2000;
        const steps = 60;
        const increment = stat.number / steps;
        let current = 0;
        
        const timer = setInterval(() => {
          current += increment;
          if (current >= stat.number) {
            current = stat.number;
            clearInterval(timer);
          }
          setCounts(prev => {
            const newCounts = [...prev];
            newCounts[index] = Math.floor(current);
            return newCounts;
          });
        }, duration / steps);
      });
    }
  }, [isVisible]);

  return (
    <section className="stats" ref={sectionRef}>
      <div className="stats__background">
        <div className="stats__pattern"></div>
      </div>
      
      <div className="stats__container">
        <div className="stats__header">
          <span className="section-label section-label--center">Our Numbers</span>
          <h2 className="section-title section-title--light" style={{ textAlign: 'center' }}>
            Building <span className="text-accent">Excellence</span> in Numbers
          </h2>
        </div>
        
        <div className="stats__grid">
          {statsData.map((stat, index) => (
            <div 
              className={`stat-card ${isVisible ? 'stat-card--visible' : ''}`}
              key={index}
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="stat-card__icon">
                <div className="stat-card__icon-bg"></div>
              </div>
              <div className="stat-card__number">
                {stat.prefix && <span className="stat-card__prefix">{stat.prefix}</span>}
                <span className="stat-card__value">{counts[index]}</span>
                {stat.suffix && <span className="stat-card__suffix">{stat.suffix}</span>}
              </div>
              <h3 className="stat-card__label">{stat.label}</h3>
              <p className="stat-card__description">{stat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;

